import { Link } from "react-router-dom";

function PurchaseCanceledPage() {
  return (
    <div style={{ background: "#f9fafb", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ maxWidth: "500px", textAlign: "center", background: "white", padding: "40px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0,0,0,0.05)" }}>
        <div style={{ fontSize: "60px", marginBottom: "20px" }}>👋</div>
        <h1 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "1.5rem", fontWeight: "700", marginBottom: "10px", color: "#6366f1" }}>Payment Canceled</h1>
        <p style={{ color: "#374151", marginBottom: "30px" }}>You have canceled the payment. Your cart items are still saved.</p>
        
        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <Link 
            to="/" 
            style={{ background: "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "white", padding: "12px 24px", borderRadius: "10px", textDecoration: "none", fontWeight: "600" }}
          >
            Try Again
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PurchaseCanceledPage;
